// AUTO-GENERATED by sync-icons — do not edit.
import type { FC, SVGProps } from 'react';
const SvgDownloadIcon: FC<SVGProps<SVGGElement>> = props => (
  <g {...props}>
    <path d="m11.22 17.64.06.05h.05l.26.23h.21q.1.009.2 0a1 1 0 0 0 .29-.06h.19l.23-.22 5-5a1.004 1.004 0 0 0-1.42-1.42L13 14.59V3a1 1 0 0 0-2 0v11.59l-3.29-3.3a1.004 1.004 0 1 0-1.42 1.42z" />
    <path d="M21 13a1 1 0 0 0-1 1v5a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-5a1 1 0 1 0-2 0v5a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3v-5a1 1 0 0 0-1-1" />
  </g>
);
export default SvgDownloadIcon;
SvgDownloadIcon.displayName = 'SvgDownloadIcon';
